import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {Field} from 'react-final-form';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import {connect} from 'react-redux';


const useStyles = makeStyles((theme) => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


function MainMultipleSelect(props){
  let select_data=(props.select_data==undefined)?[]:props.select_data;
  if(props.enum!=undefined && props.enumerations!=undefined && props.enumerations[props.enum]!=undefined){
    select_data=[];
    for(let es of props.enumerations[props.enum]){
      select_data.push({id:(props.enum_id==true)?es.id:es.value, value:(props.enum_id==true)?es.id:es.value, name:es.name});
    }
  }

  if(props.field==true){return(<Field name={props.name}>{(f)=><MultipleSelect {...props} select_data={select_data} value={f.input.value} onChange={f.input.onChange} error={(f.meta.error==undefined)?false:true} helperText={f.meta.error}/>}</Field>)}
  else{return(<MultipleSelect {...props} select_data={select_data} />)}

}


function MultipleSelect(props){
      const classes=useStyles(props);
      let v=props.value;
      console.log(v, 'VVVVV', props);
      if(v=='' || v==null || v==undefined){v=[];}
      if(v instanceof Array){}else{if(props.possible_json==true){try{v=JSON.parse(v);}catch(e){v=[v];}}else{v=[v];}}

      let translator={}; if(props.with_id==true){for(let x of props.select_data){translator[x.id]=x.name;}}

      return(
          <FormControl style={(props.style==undefined)?{width:'calc(100% - 20px)', marginLeft:'10px', backgroundColor:'#f7f9fc'}:{width:'calc(100% - 20px)', marginLeft:'10px', backgroundColor:'#f7f9fc', ...props.style}} variant='outlined' size='small'>
                  {(props.title==undefined)?null:<InputLabel id="demo-mutiple-checkbox-label" style={{ background: 'inherit', padding: '0 5px', fontSize:undefined }}>{props.title}</InputLabel>}
                  <Select
                    labelId="demo-mutiple-checkbox-label"
                    id="demo-mutiple-checkbox"
                    variant="outlined"
                    multiple
                    value={v}
                    style={{fontSize:undefined}}
                    onChange={props.onChange}
                    renderValue={(selected) =>{let res=''; for(let s of selected){if(props.with_id==true){res+=translator[s]+', ';}else{res+=s+', ';}} return res;}}
                    MenuProps={MenuProps}
                    disabled={props.disabled}
                  >
                    {props.select_data.map((data) =>{
                      let name=data;
                      if(data.name!=undefined){name=data.name;}
                      let id=name; if(props.with_id==true){id=data.id;}
                      return(
                      <MenuItem key={id} value={id}>
                        <Checkbox checked={v.indexOf(id) > -1} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    )})}
                  </Select>
                  <Typography varian='caption' style={{color:(props.error==true)?'red':undefined, marginLeft:'2px', fontSize:'10px'}}>{props.helperText}</Typography>
                </FormControl>
            )
    }




    export default connect(ss)(MainMultipleSelect);


    function ss(state){
      return{
        enumerations:state.account.enumerations
      }
    }
